import * as React from "react";
import Tag from "src/components/Common/Tags";

const YouTag = (): JSX.Element => {
  return <Tag label="YOU" size="small" sx={{ fontSize: "11px" }} />;
};

export default YouTag;
